/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputTotpVerificationResponse
 */
export interface OutputTotpVerificationResponse {
    /**
     * 
     * @type {boolean}
     * @memberof OutputTotpVerificationResponse
     */
    success?: boolean;
}

/**
 * Check if a given object implements the OutputTotpVerificationResponse interface.
 */
export function instanceOfOutputTotpVerificationResponse(value: object): boolean {
    return true;
}

export function OutputTotpVerificationResponseFromJSON(json: any): OutputTotpVerificationResponse {
    return OutputTotpVerificationResponseFromJSONTyped(json, false);
}

export function OutputTotpVerificationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputTotpVerificationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
    };
}

export function OutputTotpVerificationResponseToJSON(value?: OutputTotpVerificationResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'success': value['success'],
    };
}

